export enum InquiryType {
  ToSystem = 'ToSystem',
  ToOffice = 'ToOffice',
  ToUser   = 'ToUser',
}
